export default __webpack_public_path__ + "static/media/section4@2x.ed9e03b9.png";